import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            关于91在线视频的常见疑问解答
          </p>
        </div>

        <div className="flex flex-col gap-4">
          {faqData.map((faq) => (
            <details
              key={faq.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">{faq.question}</h3>
                <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200 group-open:bg-primary-100 transition-colors">
                  <i className="ri-add-line text-sm text-foreground-600 group-open:hidden"></i>
                  <i className="ri-subtract-line text-sm text-primary-600 hidden group-open:block"></i>
                </div>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}